import { render, staticRenderFns } from "./BlockList.vue?vue&type=template&id=2bb83c95&scoped=true&"
import script from "./BlockList.vue?vue&type=script&lang=ts&"
export * from "./BlockList.vue?vue&type=script&lang=ts&"
import style0 from "./BlockList.vue?vue&type=style&index=0&id=2bb83c95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb83c95",
  null
  
)

export default component.exports